"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/* ++++++++++ --------------- EDITABLE TEXT : DEFINITION --------------- ++++++++++ */

var _default2 = {
  name: 'EditableText',
  props: {
    textColor: {
      type: 'string',
      default: 'inherit'
    },
    outlineColor: {
      type: 'string',
      default: '#fff'
    },
    minHeight: {
      type: 'string',
      default: '100px'
    },
    scrollable: {
      type: 'boolean',
      default: false,
      options: [true, false]
    },
    defaultText: {
      type: 'string',
      default: 'Default Text Value'
    },
    placeholder: {
      type: 'string',
      default: 'Enter text ...'
    },
    onKeyUp: {
      type: 'function',
      default: function _default() {
        return console.log('key up');
      }
    },
    onKeyDown: {
      type: 'function',
      default: function _default() {
        return console.log('key down');
      }
    },
    onBlur: {
      type: 'function',
      default: function _default() {
        return console.log('blur');
      }
    },
    onFocus: {
      type: 'function',
      default: function _default() {
        return console.log('focus');
      }
    },
    onTextEdit: {
      type: 'function',
      default: function _default() {
        return console.log('text edit');
      }
    },
    validateText: {
      type: 'function',
      default: function _default() {
        return console.log('run validation');
      }
    },
    isEditable: {
      type: 'boolean',
      default: true,
      options: [true, false]
    },
    preventEnterOnKeyDown: {
      type: 'boolean',
      default: true,
      options: [true, false]
    },
    characterLimit: {
      type: 'number',
      default: 50
    },
    showCharacterCount: {
      type: 'boolean',
      default: true,
      options: [true, false]
    }
  }
};
exports.default = _default2;